module.exports = __webpack_public_path__ + "static/media/POFRITO_MENU-normal.cae7c79d.png";